import {useQuery} from 'react-query';
import {PacketPowerBaieMetric, PacketPowerCable, PacketPowerGraph} from '../Types/service';
import {getPacketPowerBaies, getPacketPowerCables, getPacketPowerGraph} from '../Api/api';

const PACKET_POWER_CABLES_QUERY_KEY = 'packet-power-cables';
const PACKET_POWER_BAIES_QUERY_KEY = 'packet-power-baies';
const PACKET_POWER_GRAPH_QUERY_KEY = 'packet-power-graph';

export const useGetPacketPowerCables = (serviceId: number) =>
  useQuery<PacketPowerCable[], unknown, PacketPowerCable[]>(
    [PACKET_POWER_CABLES_QUERY_KEY, serviceId],
    () => getPacketPowerCables(serviceId),
    {enabled: !!serviceId},
  );

export const useGetPacketPowerBaies = (serviceId: number, cable: string) =>
  useQuery<PacketPowerBaieMetric[], unknown, PacketPowerBaieMetric[]>(
    [PACKET_POWER_BAIES_QUERY_KEY, serviceId, cable],
    () => getPacketPowerBaies(serviceId, cable),
    {enabled: !!serviceId && !!cable},
  );

export const useGetPacketPowerGraph = (
  serviceId: number,
  metricId: number,
  metricName: string,
  cable: string,
  periodHours: number,
  enabled: boolean,
) =>
  useQuery<{graphs: PacketPowerGraph[]}, unknown, {graphs: PacketPowerGraph[]}>(
    [PACKET_POWER_GRAPH_QUERY_KEY, serviceId, metricId, metricName, cable, periodHours],
    () => getPacketPowerGraph(serviceId, metricName, cable, periodHours),
    {enabled, staleTime: 60_000},
  );
